module.exports = __webpack_public_path__ + "static/img/corenrImg.47f31f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/corenrImg.png
// module id = oK7S
// module chunks = 1